export default {
  results: [],
  columns: [],
  headerColumns: [],
  sitesPerUser: [],
  siteByLoggedInUser: []
};
